module.exports = __webpack_public_path__ + "static/media/no_job_photo.1bbd98be.png";